/**
 * Empty state component for lists
 */
import clsx from 'clsx';
import type { ReactElement, ReactNode } from 'react';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export default function EmptyState({ icon, title, description, action, className }: EmptyStateProps): ReactElement {
  return (
    <div className={clsx('flex flex-col items-center justify-center px-4 py-16', className)}>
      {icon && <div className="bg-slate text-ash mb-4 flex h-16 w-16 items-center justify-center rounded-full">{icon}</div>}
      <h3 className="text-pearl mb-1 text-lg font-medium">{title}</h3>
      {description && <p className="text-ash mb-4 max-w-sm text-center text-sm">{description}</p>}
      {action}
    </div>
  );
}
